<template>
    <vs-card class="tab_with_btn_holder">
        <vs-tabs>
            <vs-tab label="Payslip">
                <Payslip />
            </vs-tab>
            <vs-tab label="Payments Settings">
                <Settings />
            </vs-tab>
        </vs-tabs>
        <div class="button_like_holder">
            <strong>Next Payment Date</strong>
            <p>Tuesday 15th March, 2022</p>
        </div>
    </vs-card>
</template>

<script>
import Payslip from './payslip.vue'
import Settings from './settings.vue'

export default {
  components: {
    Payslip,
    Settings
  },
  mounted () {
  }
}
</script>